var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodeBrackets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 174,
    viewBox: "0 0 289 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_217_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53553 80.4645L81.9645 4.03553C83.9171 2.08291 87.0829 2.08291 89.0355 4.03553L97.9645 12.9645C99.9171 14.9171 99.9171 18.0829 97.9645 20.0355L37.5355 80.4645C35.5829 82.4171 35.5829 85.5829 37.5355 87.5355L97.9645 147.964C99.9171 149.917 99.9171 153.083 97.9645 155.036L89.0355 163.964C87.0829 165.917 83.9171 165.917 81.9645 163.964L5.53553 87.5355C3.58291 85.5829 3.58291 82.4171 5.53553 80.4645Z",
    fill: "#1B998B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.815 89.2636L204.613 163.878C202.615 165.784 199.45 165.71 197.544 163.712L188.827 154.576C186.921 152.578 186.995 149.413 188.993 147.507L250.823 88.5127C252.821 86.6064 252.896 83.4415 250.989 81.4436L191.995 19.6131C190.089 17.6152 190.163 14.4503 192.161 12.544L201.297 3.8271C203.295 1.92084 206.46 1.99513 208.366 3.99304L282.981 82.1945C284.887 84.1924 284.813 87.3574 282.815 89.2636Z",
    fill: "#1B998B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.155 154.047L145.714 12.0474C146.171 9.69711 148.229 8 150.623 8H162.936C166.08 8 168.444 10.8666 167.845 13.9526L140.286 155.953C139.829 158.303 137.771 160 135.377 160H123.064C119.92 160 117.556 157.133 118.155 154.047Z",
    fill: "#BAD7F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_217_21",
    x: 0.0710449,
    y: 2.44482,
    width: 288.292,
    height: 170.984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_21"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_217_21",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeBrackets);
export default __webpack_public_path__ + "static/media/code-brackets.ba7ecb54db7d157151aa251d54b6997a.svg";
export { ForwardRef as ReactComponent };